import { motion } from "framer-motion";
import {
  Package,
  Github,
  Database,
  FileText,
  NotebookPen,
  Linkedin,
  User,
} from "lucide-react";
import links from "../data/links";

const RESOURCES = [
  {
    id: "pypi",
    name: "PyPI Package",
    detail: "pypi.org/project/prometheus-ebm",
    url: links.pypi,
    Icon: Package,
    tone: "#FF4D00",
  },
  {
    id: "github-sdk",
    name: "SDK · GitHub",
    detail: "prometheus-ebm-sdk",
    url: links.github_sdk,
    Icon: Github,
    tone: "#E5E5E5",
  },
  {
    id: "kaggle-dataset",
    name: "Kaggle · Dataset",
    detail: "kaggle-agi-bm",
    url: links.kaggle_dataset,
    Icon: Database,
    tone: "#00F0FF",
  },
  {
    id: "kaggle-writeup",
    name: "Kaggle · Writeup",
    detail: "Measuring AGI · Writeup",
    url: links.kaggle_writeup,
    Icon: FileText,
    tone: "#00F0FF",
  },
  {
    id: "kaggle-notebook",
    name: "Kaggle · Notebook",
    detail: "Epistemic Metacognition Benchmark",
    url: links.kaggle_notebook,
    Icon: NotebookPen,
    tone: "#00F0FF",
  },
  {
    id: "github-profile",
    name: "GitHub · Author",
    detail: "@Mushfiqul-Alam-17",
    url: links.github_profile,
    Icon: User,
    tone: "#E5E5E5",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    detail: "mushfiqul-alam-17",
    url: links.linkedin,
    Icon: Linkedin,
    tone: "#FF4D00",
  },
];

export default function Resources() {
  return (
    <section
      id="resources"
      data-testid="resources-section"
      className="relative pt-32 pb-16 px-6 lg:px-10 border-t border-white/5 bg-[#070707]"
    >
      <div className="absolute inset-0 tech-grid opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <div className="chapter-label mb-6">07 · Resources</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-neutral-100 leading-tight max-w-4xl">
            Every artifact, in one <span className="text-[#FF4D00]">place</span>.
          </h2>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-4">
          {RESOURCES.map((r, i) => (
            <motion.a
              key={r.id}
              href={r.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`resource-${r.id}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              whileHover={{ y: -3 }}
              className="group relative border border-white/10 bg-[#0d0d0d] p-6 hover:border-white/25 transition-colors overflow-hidden w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.72rem)]"
            >
              <div
                className="absolute top-0 right-0 w-40 h-40 blur-3xl rounded-full opacity-0 group-hover:opacity-30 transition-opacity pointer-events-none"
                style={{ background: r.tone }}
              />
              <div className="relative flex items-start justify-between">
                <div>
                  <div
                    className="font-mono text-[10px] tracking-[0.3em] uppercase mb-3"
                    style={{ color: r.tone }}
                  >
                    ↗ open
                  </div>
                  <div className="font-serif-display text-2xl text-neutral-100 group-hover:text-white transition-colors">
                    {r.name}
                  </div>
                  <div className="mt-1 text-[11px] font-mono text-neutral-500 break-all">
                    {r.detail}
                  </div>
                </div>
                <div
                  className="w-11 h-11 border flex items-center justify-center transition-colors"
                  style={{
                    borderColor: r.tone + "66",
                    color: r.tone,
                  }}
                >
                  <r.Icon className="w-4 h-4" />
                </div>
              </div>
              <div
                className="absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-[900ms]"
                style={{ background: r.tone }}
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
